// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2DPXQ","moreInfoTableWrapper":"styles_moreInfoTableWrapper__T_dB0"};